import { getBasePath } from '../../config/env';
import { Configuration, PrDispatchApi } from '.';

const basePath = getBasePath() ?? '';

export const prDispatchApi = new PrDispatchApi(new Configuration({ basePath }));
